import React from "react";

export default function Interests() {
  return (
    <div className="bottom-wrapper">
      <h3>Outside of Work</h3>
      <p>
        Coffee. Meditation. Korea/Korean. Boston Red Sox. Running. Jazz music.
        Nordic Noir. Books about spirituality. Walking outside. Dogs. Being a
        good dad. Googling. Cooking.
      </p>
    </div>
  );
}
